import { gql } from 'apollo-angular';

const GET_CATEGORIZATION_SCHEMES_BY_ORG = gql`
  query getCategorizationSchemesByOrg{
    categorizationSchemesByOrg {
      id
      name
      type
      filters {
        name
        parentType
        values {
          id
          name
          type
          categorizationScheme {
            id
            name
          }
        }
      }
    }
  }
`;

export default GET_CATEGORIZATION_SCHEMES_BY_ORG;
